export default function Footer() {
  return (
    <footer className="bg-ink border-t border-gold/15" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10 py-14 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <p className="font-serif text-xl tracking-[0.28em] text-gold uppercase mb-4" data-testid="footer-wordmark">
              Joe Fenix
            </p>
            <p className="text-xs text-neutral-500 font-light leading-relaxed max-w-xs">
              A transdisciplinary biological framework for executives,
              leaders, and entrepreneurs. Mitochondrial energy. Zero burnout.
            </p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.28em] text-neutral-500 mb-4">Executive Concierge</p>
            <a
              href="mailto:info@joe-fenix-method.com"
              className="text-sm text-gold-soft hover:text-gold transition-colors duration-300 font-light"
              data-testid="footer-contact-link"
            >
              info@joe-fenix-method.com
            </a>
            <p className="text-xs text-neutral-600 font-light mt-3">Response within 48 hours. Strictly confidential.</p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.28em] text-neutral-500 mb-4">Bio-Ethics Notice</p>
            <p className="text-xs text-neutral-600 font-light leading-relaxed max-w-xs">
              The Fenix Method is a performance architecture framework and does
              not constitute medical advice. All protocols are undertaken under
              independent clinical supervision.
            </p>
          </div>
        </div>
        <div className="gold-divider mt-12 mb-7" />
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-[10px] uppercase tracking-[0.22em] text-neutral-600" data-testid="footer-copyright">
            © 2026 Joe Fenix. All Rights Reserved.
          </p>
          <p className="text-[10px] uppercase tracking-[0.22em] text-neutral-600">
            The Ultimate Version of You
          </p>
        </div>
      </div>
    </footer>
  );
}
